/** The entire stored commit message, including its subject and separators. */
export const MAX_CHANGELOG_CHARS = 5000;

/** Edit hints are bounded independently of the graph that is being published. */
export function normalizeWorkflowEditTrail(
  trail: readonly { label: string; at: number }[],
): { label: string; at: number }[] {
  return trail.slice(-500).map(({ label, at }) => ({
    label: label.length > 200 ? `${label.slice(0, 199)}…` : label,
    at,
  }));
}

/** Commit-style changelogs also accept legacy text with a single subject line. */
export function splitChangelog(text: string): {
  subject: string;
  body: string | null;
} {
  const trimmed = text.trim();
  const newline = trimmed.indexOf("\n");
  if (newline < 0) return { subject: trimmed, body: null };
  return {
    subject: trimmed.slice(0, newline).trim(),
    body: trimmed.slice(newline + 1).trim() || null,
  };
}

export function formatChangelog({
  subject,
  bullets,
}: {
  subject: string;
  bullets: readonly string[];
}): string {
  const body = bullets
    .map((bullet) => bullet.trim().replace(/^-\s+/, "").replace(/\s+/g, " "))
    .filter(Boolean)
    .map((bullet) => `- ${bullet}`)
    .join("\n");
  const summary = subject.trim().replace(/\s+/g, " ");
  return body ? `${summary}\n\n${body}` : summary;
}
